import { render, staticRenderFns } from "./TemplateInfo.vue?vue&type=template&id=10a36381"
import script from "./TemplateInfo.vue?vue&type=script&lang=js"
export * from "./TemplateInfo.vue?vue&type=script&lang=js"
import style0 from "./TemplateInfo.vue?vue&type=style&index=0&id=10a36381&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports